/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {AfterContentInit, ContentChildren, Directive, OnDestroy, QueryList} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';

import {DatagridCellRenderer} from './cell-renderer';
import {DatagridRenderOrganizer} from './render-organizer';
export class DatagridRowRenderer implements AfterContentInit, OnDestroy {
/**
 * @param {?} organizer
 */
constructor(private organizer: DatagridRenderOrganizer) {
        this.subscription = organizer.alignColumns.subscribe(() => this.setWidths());
    }
private subscription: Subscription;
/**
 * @return {?}
 */
ngOnDestroy() {
        this.subscription.unsubscribe();
    }

     cells: QueryList<DatagridCellRenderer>;
/**
 * @return {?}
 */
private setWidths() {
        if (this.organizer.widths.length !== this.cells.length) {
            return;
        }
        this.cells.forEach((cell, index) => {
            const /** @type {?} */ width = this.organizer.widths[index];
            cell.setWidth(width.strict, width.px);
        });
    }
/**
 * @return {?}
 */
ngAfterContentInit() {
        this.cells.changes.subscribe(() => {
            this.setWidths();
        });
    }
/**
 * @return {?}
 */
ngAfterViewInit() {
        this.setWidths();
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: "clr-dg-row, clr-dg-row-detail"}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: DatagridRenderOrganizer, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'cells': [{ type: ContentChildren, args: [DatagridCellRenderer, ] },],
};
}

function DatagridRowRenderer_tsickle_Closure_declarations() {
/** @type {?} */
DatagridRowRenderer.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DatagridRowRenderer.ctorParameters;
/** @type {?} */
DatagridRowRenderer.propDecorators;
/** @type {?} */
DatagridRowRenderer.prototype.subscription;
/** @type {?} */
DatagridRowRenderer.prototype.cells;
/** @type {?} */
DatagridRowRenderer.prototype.organizer;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
